/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { WidgetGuard } from 'features/types'
import { SocialWebStoryScopeWidget } from 'schemas/SocialWebStoryScopeWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { createSearches } from './utils'

const RunSearchEffect: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebStoryScopeWidget>(widgetId)
  const { id: dashboardId, name } = useDashboardData() as Dashboard
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const searches = createSearches(widgetSetting, dashboardId!, name!)

    dispatch(
      getWidgetForDashboard({
        searches,
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardId, name, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
